module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'f71zo7km',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
